module.exports = __webpack_public_path__ + "img/Lupa.75651ebc.svg";